<template>
    <div>
        <b-row class="service-request-filters-row">
            <b-col cols="12" sm="12" md="3" class="mb-2 mb-md-0 ml-auto">
                <eb-select
                    class="select-background-white"
                    id="text"
                    type="text"
                    label="text"
                    :options="dateOption"
                    v-model="selectedDate"
                    :selected="selectedDate.text"
                    @input="changeDate"
                >
                </eb-select>
                <b-modal
                    title="Select Date"
                    header-class="header-nipige-class"
                    id="dateRange"
                    size="sm"
                    ref="date-range"
                    centered
                    hide-footer
                >
                    <b-input
                        class="mb-2"
                        type="date"
                        v-model="startDate"
                    ></b-input>
                    <b-input type="date" v-model="endDate"></b-input>
                    <div class="text-center mt-2">
                        <b-button
                            @click="findButtonClick()"
                            class="my -0 main-navigation-button w-47 mr-2"
                            variant="success"
                            >Find
                        </b-button>
                    </div>
                </b-modal>
            </b-col>
        </b-row>
        <b-row class="service-request-row">
            <b-col
                cols="12"
                sm="12"
                md="4"
                class="text-center mb-3 mb-md-0"
                v-if="
                    getChartData &&
                    getChartData.labels &&
                    getChartData.labels.length > 0
                "
            >
                <div class="left-vl">
                    <h4 class="text-center chart-title">SERVICE REQUEST STATISTICS</h4>
                    <Doughnut
                        class="piechart"
                        :data="getChartData"
                        :chart-data="getChartData"
                        :options="chartOptions"
                        :chart-options="chartOptions"
                    ></Doughnut>
                </div>
            </b-col>
            <b-col cols="12" sm="12" :md="getChartData && getChartData.labels && getChartData.labels.length > 0 ? 8 : 12">
                <div class="table-wrapper">
                    <b-table
                        class="service-request-table"
                        striped
                        show-empty
                        responsive
                        hover
                        :fields="title"
                        thead-class="header"
                        :items="getServiceTicketList"
                        :bordered="true"
                        @filtered="onFilter"
                        :current-page="currentPage"
                        :per-page="perPage"
                    >
                    <template slot="cell(date)" slot-scope="data">
                        <div class="table-row">
                            {{ data.item.date | formatedate }}
                        </div>
                    </template>
                    <template slot="cell(action)" slot-scope="data">
                        <b-button
                            size="sm"
                            class="mr-2"
                            variant="primary"
                            @click="
                                $router.push({
                                    name: 'service-request-details',
                                    params: {
                                        id: data.item._id,
                                        customerId: currentUser.id,
                                    },
                                })
                            "
                        >
                            <i class="fa fa-eye"></i>
                        </b-button>
                    </template>
                    </b-table>
                </div>
                <div class="pagination-wrapper">
                    <b-pagination
                        v-model="currentPage"
                        :per-page="perPage"
                        :total-rows="filterCount"
                        aria-controls="my-table"
                        prev-text="Prev"
                        next-text="Next"
                        hide-goto-end-buttons
                    ></b-pagination>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
import ebSelect from "@/components/FormElements/Select.vue";
import PieChart from "@/components/chart/piechart.js";
import Doughnut from "@/components/chart/Doughnut.js";
import moment from "moment";
export default {
    components: {
        VueSimpleSuggest,
        ebSelect,
        PieChart,
        Doughnut,
    },
    data() {
        return {
            perPage: 7,
            currentPage: 1,
            filterCount: 0,
            chartOptions: {
                hoverBorderWidth: 10,
            },
            title: [
                {
                    key: "date",
                    label: "Date",
                },
                {
                    key: "ticketNo",
                    label: "SR Number",
                },
                {
                    key: "description",
                    label: "Description",
                },

                {
                    key: "status",
                    label: "Status",
                },
                {
                    key: "action",
                    label: "Action",
                },
            ],
            selectedDate: {
                text: "Today",
                value: 1,
            },
            dateOption: [
                {
                    text: "Today",
                    value: 1,
                },
                {
                    text: "7 day's",
                    value: 7,
                },
                {
                    text: "30 day's",
                    value: 30,
                },
                {
                    text: "Custom",
                    value: "custom",
                },
            ],
            startDate: "",
            endDate: "",
            currentUser: "",
        };
    },
    filters: {
        formatedate: function (value) {
            if (value) {
                return moment(String(value)).format("DD/MM/YYYY hh:mm A");
            }
        },
    },
    computed: {
        getServiceTicketList() {
            let data =
                this.$store.getters["customerManagement/GetServiceTicketList"];
            const ticket = data && data.data ? data.data.data : "";
            const ticketList = [];
            ticket
                ? ticket.map((obj) => {
                      let arrayObj = {
                          date: obj.createdAt,
                          ticketNo: obj.ticketNo,
                          description: obj.description,
                          status: obj.status,
                          ...obj,
                      };
                      ticketList.push(arrayObj);
                  })
                : "";
            return ticketList;
        },
        getChartData() {
            let dataList =
                this.$store.getters[
                    "customerManagement/GetServiceRequestGraph"
                ];
            const labels = [];
            const data = [];
            if (
                dataList &&
                dataList.data &&
                Array.isArray(dataList.data) &&
                dataList.data?.length &&
                dataList.data[0].statistic &&
                Array.isArray(dataList.data[0].statistic)
            ) {
                dataList.data[0].statistic.map((x) => {
                    labels.push(x.status);
                    data.push(x.total);
                });
                return {
                    hoverBackgroundColor: "red",
                    hoverBorderWidth: 10,
                    labels: labels,
                    datasets: [
                        {
                            label: "Data One",
                            backgroundColor: ["#CBB6F8", "#5E3FBE"],
                            data: data,
                        },
                    ],
                };
            } else {
                // return {};
            }
        },
    },
    methods: {
        onFilter(list) {
            this.filterCount = list.length;
            this.currentPage = 1;
        },
        findButtonClick() {
            let e = {
                fromDate: this.startDate,
                toDate: this.endDate,
            };
            this.$refs["date-range"].hide();
            this.fetchChartData();
            this.fetchServiceTicket();
        },
        changeDate(e) {
            this.selectedDate = e;
            if (e.value == "custom") {
                this.$refs["date-range"].show();
                return;
            }
            this.fetchChartData();
            this.fetchServiceTicket();
        },
        getDateData(dateData) {
            if (dateData == "custom") {
                const data = {
                    fromDate: this.startDate,
                    toDate: this.endDate,
                };
                return data;
            }
            if (dateData == 1) {
                const data = {
                    fromDate: moment().format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                return data;
            } else {
                const data = {
                    fromDate: moment()
                        .subtract(30, "days")
                        .format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                if (typeof dateData === "number") {
                    data.fromDate = moment()
                        .subtract(dateData, "days")
                        .format("YYYY-MM-DD");
                    return data;
                } else if (typeof dateData === "object") {
                    return dateData;
                }
                return data;
            }
        },
        createService() {
            this.$router.push({
                path: "/createServieRequest",
            });
        },
        async fetchServiceTicket() {
            const payload = {
                status: "",
                priority: null,
                category: "",
                reportedTo: "",
                assignTo: "",
                ...this.getDateData(this.selectedDate.value),
            };
            await this.$store.dispatch(
                "customerManagement/serviceTicketList",
                payload,
            );
        },
        async fetchChartData() {
            const payload = {
                customerId: this.currentUser.id,
                ...this.getDateData(this.selectedDate.value),
            };

            await this.$store.dispatch(
                "customerManagement/serviceRequestGraph",
                payload,
            );
        },
    },
    async mounted() {
        this.currentUser = this.$route.params;
        await this.fetchServiceTicket();
        await this.fetchChartData();
    },
};
</script>
<style scoped>
.vl {
    border-left: 1px solid grey;
    height: 400px;
}

.left-vl {
    border-right: 1px solid grey;
    height: 400px;
    padding-right: 1rem;
}

.select-background-white {
    background-color: #fff;
}

.table-wrapper {
    overflow-x: auto;
    width: 100%;
}

.service-request-table {
    border-radius: 12px;
}

.pagination-wrapper {
    float: right;
    margin-top: 1rem;
}

.service-request-filters-row {
    align-items: flex-end;
}

.service-request-row {
    align-items: flex-start;
}

.chart-title {
    margin-bottom: 1rem;
}

@media (max-width: 991.98px) {
    .left-vl {
        border-right: none;
        border-bottom: 1px solid grey;
        height: auto;
        padding-right: 0;
        padding-bottom: 1rem;
        margin-bottom: 1rem;
    }
}

@media (max-width: 767.98px) {
    .pagination-wrapper {
        float: none;
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 1rem;
    }

    .table-wrapper {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }

    .chart-title {
        font-size: 1rem;
    }
}
</style>
